import axios from "axios";

type UserPathwayDataReturn = {
  getPersonalPathwayStepCompletionById: (userId: string, stepId: string) => Promise<boolean>;
  getTeamPathwayStepCompletionById: (userId: string, stepId: string) => Promise<boolean>;
};

async function getPersonalPathwayStepCompletionById(userId: string, stepId: string) {
  const response = await axios.get<boolean>(
    `/api/personalpathway/stepcompletion/${userId}/${stepId}`,
  );
  return response.data;
}

async function getTeamPathwayStepCompletionById(userId: string, stepId: string) {
  const response = await axios.get<boolean>(`/api/teampathway/stepcompletion/${userId}/${stepId}`);
  return response.data;
}

function useGetUserPathwayData(): UserPathwayDataReturn {
  return { getPersonalPathwayStepCompletionById, getTeamPathwayStepCompletionById };
}

export default useGetUserPathwayData;
